/*
 * File: Routes.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The routes used in the schedule area
 */
import AppointmentsPage from "./pages/AppointmentsPage";
import AppointmentPage from "./pages/AppointmentPage";

const Routes = [
  {
    path: "/appointments",
    component: AppointmentsPage,
    exact: true
  },
  {
    path: "/appointments/:appointmentId",
    component: AppointmentPage
  }
];

export default Routes;
